export default "/fonts/vendor/primeicons/primeicons.ttf?a5c2a53d1ff7a9ff5933b9b2da15b899";